const postTranslations = async (content, to_language) => {
  const dataSend = {
    content,
    preserve_format: true,
    to_language,
  };
  try {
    const res = await fetch(`/api/telsyml/translate`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(dataSend),
      method: 'POST',
    });
    if (!res.ok || (res.status >= 400 && res.status < 600)) {
      return await res;
    }
    return await res.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export default postTranslations;
